import type {
  BuildResult,
  SiteBuildDiagnostic,
} from "../types/site-builder-types";

export interface SuccessfulBuildResultOptions {
  outputDir: string;
  filesGenerated: number;
  routesBuilt: number;
  warnings: string[];
  diagnostics?: SiteBuildDiagnostic[] | undefined;
  skipped?: boolean | undefined;
}

export function createSuccessfulBuildResult(
  options: SuccessfulBuildResultOptions,
): BuildResult {
  return {
    success: true,
    outputDir: options.outputDir,
    filesGenerated: options.filesGenerated,
    routesBuilt: options.routesBuilt,
    ...(options.skipped && { skipped: true }),
    ...(options.warnings.length > 0 && { warnings: options.warnings }),
    ...(options.diagnostics &&
      options.diagnostics.length > 0 && {
        diagnostics: options.diagnostics,
      }),
  };
}

export interface CancelledBuildResultOptions {
  outputDir: string;
  message: string;
  diagnostics: SiteBuildDiagnostic[];
}

export function createCancelledBuildResult(
  options: CancelledBuildResultOptions,
): BuildResult {
  return {
    success: false,
    cancelled: true,
    outputDir: options.outputDir,
    filesGenerated: 0,
    routesBuilt: 0,
    errors: [options.message],
    diagnostics: options.diagnostics,
  };
}

export interface FailedBuildResultOptions {
  outputDir: string;
  errorMessages: string[];
  diagnostics?: SiteBuildDiagnostic[] | undefined;
}

export function createFailedBuildResult(
  options: FailedBuildResultOptions,
): BuildResult {
  return {
    success: false,
    outputDir: options.outputDir,
    filesGenerated: 0,
    routesBuilt: 0,
    errors: options.errorMessages,
    ...(options.diagnostics &&
      options.diagnostics.length > 0 && {
        diagnostics: options.diagnostics,
      }),
  };
}
